module.exports = __webpack_public_path__ + "img/img_case2.b8c67d54.png";